import { render, staticRenderFns } from "./dossier-external-candidate.vue?vue&type=template&id=646370ca&"
import script from "./dossier-external-candidate.vue?vue&type=script&lang=js&"
export * from "./dossier-external-candidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports